import React from 'react';
import { Paper, Typography } from '@material-ui/core';
import Box from '@mui/material/Box';
import { useHistory, useLocation } from 'react-router-dom';
const BackgroundTheme = (props: any) => {
  const { children } = props;
  const location = useLocation();
  return <Box className={location.pathname === '/p2p/lenderAgreement' ||
  location.pathname === '/p2p/personalInfo' ||
  location.pathname === '/p2p/personalInfoSecond' ||
  location.pathname === '/p2p/connectBank'
  ? 'contentAreaOld column-fluid' :'contentArea column-fluid'}>{children}</Box>;
};

export default BackgroundTheme;
